import React from 'react';

// --- Image Scroller Component for Landing Page ---
export const ImageScroller = ({ images, speed = "80s", edge = "10vw" }) => {
  // Seamless loop when content is duplicated once → translate to -50%
  const animationName = "scroll-left";
  const keyframes = `
    @keyframes ${animationName} {
      from { transform: translateX(0%); }
      to   { transform: translateX(-50%); }
    }
  `;

  return (
    <>
      <style>{keyframes}</style>

      {/* Full-bleed wrapper (breaks out of centered parent) */}
      <div
        className="
          relative left-1/2 right-1/2 w-screen -ml-[50vw] -mr-[50vw]
          overflow-hidden
        "
        style={{
          // Fade edges: both standard and WebKit (Safari) masks
          // linear-gradient(to right, transparent … black … black … transparent)
          "--edge": edge,
          maskImage:
            "linear-gradient(to right, transparent 0, black var(--edge), black calc(100% - var(--edge)), transparent 100%)",
          WebkitMaskImage:
            "linear-gradient(to right, transparent 0, black var(--edge), black calc(100% - var(--edge)), transparent 100%)",
        }}
      >
        <ul
          className="
            flex flex-nowrap w-max
            [&_li]:mx-4 [&_img]:max-w-none
          "
          style={{
            animationName,
            animationDuration: speed,
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
          }}
        >
          {/* original set */}
          {images.map((image, i) => (
            <li key={i} className="flex-shrink-0">
              <img
                src={image.url}
                alt={image.alt}
                className="rounded-lg shadow-lg aspect-[4/5] object-cover h-48 md:h-64"
              />
            </li>
          ))}

          {/* duplicated set for seamless scroll */}
          {images.map((image, i) => (
            <li key={`dup-${i}`} className="flex-shrink-0" aria-hidden="true">
              <img
                src={image.url}
                alt={image.alt}
                className="rounded-lg shadow-lg aspect-[4/5] object-cover h-48 md:h-64"
              />
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default ImageScroller;
